import { useMemo } from 'react';
import { createPortal } from 'react-dom';
import type { Bank } from '../types';
import { typeTag } from '../utils';

const TYPES = ['全部', 'single', 'multiple', 'blank'];

interface Props {
  bank: Bank;
  chapterFilter: string;
  typeFilter: string;
  open: boolean;
  onToggle: () => void;
  onChapter: (v: string) => void;
  onType: (v: string) => void;
  onReset: () => void;
}

export function FilterBar({ bank, chapterFilter, typeFilter, open, onToggle, onChapter, onType, onReset }: Props) {
  const chapters = useMemo(() => {
    const list: string[] = ['全部'];
    bank.by_chapter?.forEach(c => { if (!list.includes(c.chapter)) list.push(c.chapter); });
    bank.questions.forEach(q => { if (q.chapter && !list.includes(q.chapter)) list.push(q.chapter); });
    return list;
  }, [bank]);

  const summary =
    (chapterFilter === '全部' ? '全部章节' : chapterFilter) +
    ' · ' +
    (typeFilter === '全部' ? '全部题型' : typeTag(typeFilter));

  const chapterChips = chapters.map(c => (
    <button key={c} className={`chip${c === chapterFilter ? ' active' : ''}`} onClick={() => onChapter(c)}>
      {c}
    </button>
  ));
  const typeChips = TYPES.map(t => (
    <button key={t} className={`chip${t === typeFilter ? ' active' : ''}`} onClick={() => onType(t)}>
      {t === '全部' ? '全部' : typeTag(t)}
    </button>
  ));

  return (
    <>
      {/* 桌面端折叠面板（移动端 CSS 隐藏，入口在底部操作栏） */}
      <div className={`filter-bar${open ? ' open' : ''}`}>
        <button className="collapse-toggle" onClick={onToggle}>
          <span className="collapse-title">筛选</span>
          <span className="summary">{summary}</span>
          <span className="arrow">▾</span>
        </button>
        <div className="collapse-body">
          <div className="filter-row">
            <span className="label">章节：</span>
            <span className="chapter-chips">{chapterChips}</span>
          </div>
          <div className="filter-row" style={{ marginTop: 10 }}>
            <span className="label">题型：</span>
            <span className="type-chips">{typeChips}</span>
          </div>
          <div className="filter-footer">
            <button className="btn secondary" onClick={onReset}>重置筛选</button>
          </div>
        </div>
      </div>

      {/* 移动端底部抽屉：Portal 渲染到 body，脱离滚动容器，保证内部可正常滚动 */}
      {open && createPortal(
        <div className="sheet-wrap">
          <div className="sheet-backdrop" onClick={onToggle} />
          <div className="sheet-panel">
            <div className="sheet-head">
              <span className="sheet-title">筛选题目</span>
              <button className="sheet-close" onClick={onToggle} aria-label="关闭">✕</button>
            </div>
            <div className="filter-row">
              <span className="label">章节：</span>
              <span className="chapter-chips">{chapterChips}</span>
            </div>
            <div className="filter-row" style={{ marginTop: 10 }}>
              <span className="label">题型：</span>
              <span className="type-chips">{typeChips}</span>
            </div>
            <div className="filter-footer">
              <button className="btn secondary" onClick={onReset}>重置筛选</button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
